import { useEffect } from "react";
import { Outlet, useOutletContext, useParams } from "react-router-dom";
import { InspectionsPageContext } from "../InspectionsPage";
import InspectionDataSideMenu from "./components/InspectionDataSideMenu";

export function InspectionsDataPage(props: any) {
  const params = useParams();
  const id = params["id"] ?? "";
  const context: InspectionsPageContext = useOutletContext();

  useEffect(() => {
    context.setSidemenu(<InspectionDataSideMenu inspectionId={Number(id)} />);
  }, [id]);

  return (
    <Outlet context={context} />
  );
}

export default InspectionsDataPage;

